import React, { useState, useEffect } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ButtonDefault from 'component/button.component';
import {
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';
import recordRepository from 'repositories/records';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { toast } from 'react-toastify';
import history from 'config/history';

import { Container } from './records.style';

function Template(props) {
  let recordInfo;
  let isEdit = false;
  let eventInfo;
  let templateInfo;
  let title;
  let claimantOAB;
  let claimantUF;
  let claimantLawyer;
  let claimedOAB;
  let claimedUF;
  let claimedLawyer;
  let claimed;
  let claimant;
  let court;
  let city;
  let filledTemplate;
  let isClaimant;
  let initialState;

  useEffect(() => {
    let timerFunc = setTimeout(() => {
      if (props.history.location.state[1].isRecordEdit) {
        recordInfo = props.history.location.state[0];
        templateInfo = props.history.location.state[0].record;
        title = props.history.location.state[1].title;
        initialState = {
          template: recordInfo.record,
          title,
          isEdit: true,
        };
        isEdit = true;
      } else {
        eventInfo = props.history.location.state[0];
        templateInfo = props.history.location.state[1];
        title = templateInfo.template_name;
        court = eventInfo.Courts_court;

        //verify which party comes first to fill isClaimant variable
        const firstTag = templateInfo.template.split(
          /&lt;reu-autor\/&gt;|<reu-autor\/>|&lt;reu\/&gt;|<reu\/>/
        )[0];
        isClaimant =
          firstTag.includes('&lt;autor-reu/&gt;') ||
          firstTag.includes('&lt;autor/&gt;') ||
          firstTag.includes('<autor-reu/>') ||
          firstTag.includes('<autor/>');

        court = court.replace('VT', 'VARA DO TRABALHO');
        city = court.substring(court.indexOf('TRABALHO D') + 12, court.length);

        const temp = fillTemplate();
        initialState = {
          processNumber: '',
          court: '',
          claimant: '',
          claimed: '',
          lawyer: '',
          oabInitials: '',
          oabNumber: '',
          claimantOAB: '',
          claimantUF: '',
          claimantLawyer: '',
          claimedOAB: '',
          claimedUF: '',
          claimedLawyer: '',
          date: '',
          title: title || '',
          template: temp,
          rawTemplate: fillTemplateWithoutParties(),
        };
      }

      if (!isEdit) {
        initialState = {
          ...initialState,
          processNumber: eventInfo.process_number,
          court,
          claimant,
          claimed,
          lawyer: claimantLawyer,
          oabInitials: claimantUF,
          oabNumber: claimantOAB,
          rawTemplate: filledTemplate,
          isEdit: false,
        };
        setState(initialState);
      } else {
        initialState = {
          ...initialState,
          processNumber: recordInfo.process_number,
          templateId: recordInfo.id,
          eventId: recordInfo.event_id,
          template: recordInfo.record,
        };
        setState(initialState);
      }
    }, 500);

    return () => clearTimeout(timerFunc);
  }, []);

  const [state, setState] = useState([]);
  const [opening, setOpening] = useState(true);
  const [open, setOpen] = useState(false);

  function processString(text) {
    let loweredText = text.toLowerCase();
    let wordsArray = loweredText.split(' ');

    let words = wordsArray.map(word => {
      let firstLetter = word[0];
      if (word.length > 2) {
        return firstLetter.toUpperCase() + word.slice(1);
      } else {
        return firstLetter + word.slice(1);
      }
    });
    return words.join(' ');
  }

  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  const dataExtenso = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth();
    const year = today.getFullYear();
    const cityUpper = processString(city);
    return `${cityUpper}, ${day} de ${months[month]} de ${year}`;
  };

  function getEventInfo() {
    claimantOAB = '';
    claimantUF = '';
    claimantLawyer = '';
    claimedOAB = '';
    claimedUF = '';
    claimedLawyer = '';
    claimed = '';
    claimant = '';
    if (!state.isEdit) {
      eventInfo.parties.forEach(party => {
        switch (party.party_type_id) {
          case 1:
            if (party.name !== null && party.name !== '') {
              claimant += `${party.name};`;
            }
            break;
          case 2:
            if (party.name !== null && party.name !== '')
              claimed += `${party.name};`;
            break;
          case 3:
            if (
              party.lawyer_oab !== '' &&
              party.lawyer_oab !== null &&
              party.name !== '' &&
              party.name !== null
            ) {
              claimantOAB += `${party.lawyer_oab.match(/^.*(?=(\/))/g)};`;
              claimantUF += `${party.lawyer_oab.match(/[^\/]*$/g)};`;
              claimantLawyer += `${party.name};`;
            }
            break;
          case 4:
            if (
              party.lawyer_oab !== '' &&
              party.lawyer_oab !== null &&
              party.name !== '' &&
              party.name !== null
            ) {
              claimedOAB += `${party.lawyer_oab.match(/^.*(?=(\/))/g)};`;
              claimedUF += `${party.lawyer_oab.match(/[^\/]*$/g)};`;
              claimedLawyer += `${party.name};`;
            }
            break;
          default:
            break;
        }
      });

      claimantOAB = claimantOAB.replace(/;$/g, '').trim();
      claimantUF = claimantUF
        .replace(/;$/g, '')
        .replace(/,/g, '')
        .trim();
      claimantLawyer = claimantLawyer.replace(/;$/g, '').trim();
      claimedOAB = claimedOAB.replace(/;$/g, '').trim();
      claimedUF = claimedUF
        .replace(/;$/g, '')
        .replace(/,/g, '')
        .trim();
      claimedLawyer = claimedLawyer.replace(/;$/g, '').trim();
      claimant = claimant.replace(/;$/g, '').trim();
      claimed = claimed.replace(/;$/g, '').trim();
    }
  }

  const fillTemplate = () => {
    if (!state.isEdit) {
      let filledTemplate = templateInfo.template;

      getEventInfo();

      return (filledTemplate = filledTemplate
        .replace(/<vara\/>|&lt;vara\/&gt;/g, court)
        .replace(/<processo\/>|&lt;processo\/&gt;/g, eventInfo.process_number)
        .replace(/<data-extenso\/>|&lt;data-extenso\/&gt;/g, dataExtenso())
        .replace(
          /<advogado\/>|&lt;advogado\/&gt;/g,
          isClaimant ? claimantLawyer : claimedLawyer
        )
        .replace(
          /<oab-sigla\/>|&lt;oab-sigla\/&gt;/g,
          isClaimant ? claimantUF : claimedUF
        )
        .replace(
          /<oab-numero\/>|&lt;oab-numero\/&gt;/g,
          isClaimant ? claimantOAB : claimedOAB
        )
        .replace(/<autor\/>|&lt;autor\/&gt;/g, claimant)
        .replace(/<reu\/>|&lt;reu\/&gt;/g, claimed)
        .replace(/<autor-reu\/>|&lt;autor-reu\/&gt;/, claimant)
        .replace(/(<autor-reu\/>|&lt;autor-reu\/&gt;)(?!.*\1)/g, claimant)
        .replace(/<reu-autor\/>|&lt;reu-autor\/&gt;/, claimed)
        .replace(/(<reu-autor\/>|&lt;reu-autor\/&gt;)(?!.*\1)/g, claimed));
    }
  };

  const fillTemplateWithoutParties = () => {
    if (!state.isEdit) {
      filledTemplate = templateInfo.template;

      return (filledTemplate = filledTemplate
        .replace(/<vara\/>|&lt;vara\/&gt;/g, court)
        .replace(/<processo\/>|&lt;processo\/&gt;/g, eventInfo.process_number)
        .replace(/<data-extenso\/>|&lt;data-extenso\/&gt;/g, dataExtenso())
        .replace(/<autor\/>|&lt;autor\/&gt;/g, claimant)
        .replace(/<reu\/>|&lt;reu\/&gt;/g, claimed));
    }
  };

  const insertRecord = () => {
    const record = {
      eventId: eventInfo.id,
      templateId: templateInfo.id,
      processNumber: eventInfo.process_number,
      record: state.template,
    };
    recordRepository.addRecord(record).then(() => {
      history.push('/acompanhar-agenda');
      toast.success('Minuta salva com sucesso!');
    });
  };

  const updateRecord = () => {
    const record = {
      templateId: state.templateId,
      eventId: state.eventId,
      processNumber: state.processNumber,
      record: state.template,
    };
    recordRepository.updateRecord(record).then(() => {
      toast.success('Minuta alterada com sucesso!');
    });
  };

  const templateDownload = () => {
    recordRepository.templateDownload({
      title: state.title,
      text: state.template,
    });
  };

  function fillTemplateClaimant() {
    let templateParty = '';

    if (
      (state.rawTemplate.includes('&lt;autor-reu/&gt;') &&
        state.rawTemplate.includes('&lt;reu-autor/&gt;')) ||
      (state.rawTemplate.includes('<autor-reu/>') &&
        state.rawTemplate.includes('<reu-autor/>'))
    ) {
      templateParty = state.rawTemplate
        .replace(/<autor-reu\/>|&lt;autor-reu\/&gt;/, state.claimant)
        .replace(/(<reu-autor\/>|&lt;reu-autor\/&gt;)(?!.*\1)/g, state.claimed);
    } else if (
      state.rawTemplate.includes('<autor-reu/>') ||
      state.rawTemplate.includes('&lt;autor-reu/&gt;')
    ) {
      templateParty = state.rawTemplate
        .replace(/<autor-reu\/>|&lt;autor-reu\/&gt;/, state.claimant)
        .replace(
          /(<autor-reu\/>|&lt;autor-reu\/&gt;)(?!.*\1)/g,
          state.claimant
        );
    } else if (
      state.rawTemplate.includes('<reu-autor/>') ||
      state.rawTemplate.includes('&lt;reu-autor/&gt;')
    ) {
      templateParty = state.rawTemplate
        .replace(/<reu-autor\/>|&lt;reu-autor\/&gt;/, state.claimed)
        .replace(/(<reu-autor\/>|&lt;reu-autor\/&gt;)(?!.*\1)/g, state.claimed);
    }

    templateParty = templateParty
      .replace(/<advogado\/>|&lt;advogado\/&gt;/, claimantLawyer)
      .replace(/<oab-sigla\/>|&lt;oab-sigla\/&gt;/, claimantUF)
      .replace(/<oab-numero\/>|&lt;oab-numero\/&gt;/, claimantOAB);

    setState({
      ...state,
      rawTemplate: state.rawTemplate,
      claimant: state.claimant,
      claimed: state.claimed,
      template: templateParty,
    });
  }

  function fillTemplateClaimed() {
    let templateParty = '';

    if (
      (state.rawTemplate.includes('&lt;autor-reu/&gt;') &&
        state.rawTemplate.includes('&lt;reu-autor/&gt;')) ||
      (state.rawTemplate.includes('<autor-reu/>') &&
        state.rawTemplate.includes('<reu-autor/>'))
    ) {
      templateParty = state.rawTemplate
        .replace(/<autor-reu\/>|&lt;autor-reu\/&gt;/, state.claimed)
        .replace(
          /(<reu-autor\/>|&lt;reu-autor\/&gt;)(?!.*\1)/g,
          state.claimant
        );
    } else if (
      state.rawTemplate.includes('<autor-reu/>') ||
      state.rawTemplate.includes('&lt;autor-reu/&gt;')
    ) {
      templateParty = state.rawTemplate
        .replace(/<autor-reu\/>|&lt;autor-reu\/&gt;/, state.claimed)
        .replace(
          /(<autor-reu\/>|&lt;autor-reu\/&gt;)(?!.*\1)/g,
          state.claimant
        );
    } else if (
      state.rawTemplate.includes('<reu-autor/>') ||
      state.rawTemplate.includes('&lt;reu-autor/&gt;')
    ) {
      templateParty = state.rawTemplate
        .replace(/<reu-autor\/>|&lt;reu-autor\/&gt;/, state.claimed)
        .replace(
          /(<reu-autor\/>|&lt;reu-autor\/&gt;)(?!.*\1)/g,
          state.claimant
        );
    }

    templateParty = templateParty
      .replace(/<advogado\/>|&lt;advogado\/&gt;/, claimedLawyer)
      .replace(/<oab-sigla\/>|&lt;oab-sigla\/&gt;/, claimedUF)
      .replace(/<oab-numero\/>|&lt;oab-numero\/&gt;/, claimedOAB);

    setState({
      ...state,
      rawTemplate: state.rawTemplate,
      claimant: state.claimant,
      claimed: state.claimed,
      template: templateParty,
    });
  }

  const recordRegister = Yup.object().shape({
    template: Yup.string().required('Texto da minuta é necessário'),
  });

  const onChangeText = content => {
    setState(prevState => ({
      ...prevState,
      template: content,
    }));
  };

  function handleOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={state}
      validationSchema={recordRegister}
    >
      {({ errors, touched, validateForm, setTouched }) => (
        <div>
          <h3 align="center" style={{ paddingTop: 8, fontWeight: 'bold' }}>
            Minuta: {state.title}
          </h3>
          <div className="flex-column align-stretch">
            <Form>
              <div className="flex-row align-stretch justify-center self-align-center">
                {!state.isEdit && (
                  <div
                    className="flex-column"
                    style={{
                      marginBottom: '10px',
                      border: '1px solid rgba(164,164,164,0.3)',
                      borderRadius: '6px',
                      padding: '5px',
                      backgroundColor: '#ffffff',
                      width: 200,
                      textAlign: 'center',
                    }}
                  >
                    <span style={{ fontWeight: 'bold' }}>Opções da minuta</span>

                    <div>
                      <ButtonDefault
                        onClick={() => fillTemplateClaimant()}
                        text="Reclamante"
                        style={{
                          marginLeft: 0,
                          marginTop: 10,
                          backgroundColor: '#185335',
                        }}
                      />
                      <ButtonDefault
                        onClick={() => fillTemplateClaimed()}
                        text="Reclamado"
                        style={{
                          marginLeft: 0,
                          marginTop: 10,
                          backgroundColor: '#185335',
                        }}
                      />
                    </div>
                  </div>
                )}
                <Container>
                  <FormControl
                    error={errors.template}
                    style={{ marginTop: 10 }}
                  >
                    <CKEditor
                      editor={ClassicEditor}
                      data={state.template}
                      onChange={(event, editor) => {
                        onChangeText(editor.getData());
                      }}
                    />
                    <FormHelperText error={errors.template}>
                      {errors.template && 'Texto da minuta necessário'}
                    </FormHelperText>
                  </FormControl>
                </Container>
                <div
                  className="flex-column align-stretch"
                  style={{
                    marginBottom: '10px',
                    border: '1px solid rgba(164,164,164,0.3)',
                    borderRadius: '6px',
                    padding: '5px',
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    width: 300,
                  }}
                >
                  <span style={{ fontWeight: 'bold' }}>Ações da minuta</span>
                  {!state.isEdit ? (
                    <ButtonDefault
                      onClick={handleOpen}
                      text="Salvar"
                      style={{
                        marginLeft: 0,
                        marginTop: 10,
                        backgroundColor: '#185335',
                      }}
                    />
                  ) : (
                    <ButtonDefault
                      onClick={updateRecord}
                      text="Alterar"
                      style={{
                        marginLeft: 0,
                        marginTop: 10,
                        backgroundColor: '#185335',
                      }}
                    />
                  )}
                  <ButtonDefault
                    onClick={templateDownload}
                    text="Baixar Minuta"
                    style={{
                      marginLeft: 0,
                      marginTop: 10,
                      backgroundColor: '#185335',
                    }}
                  />
                </div>
              </div>
            </Form>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title">
                Realmente deseja salvar a minuta?
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Após o salvamento {<strong>não</strong>} será possível
                  utilizar as opções da minuta.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={insertRecord} color="primary">
                  Sim
                </Button>
                <Button autoFocus onClick={handleClose} color="secondary">
                  Não
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default Template;
